import React from 'react';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { FormattedMessage } from 'react-intl';
import TableMobile from './tableMobile';
import Check from '../assets/check.svg';
import Close from '../assets/close.svg';
import Tip from '../../../components/Tip';

const Mobile = styled.div`
  ${breakpoint('desktop')`
    display: none;
  `};
`;

const Desktop = styled.div`
  display: none;

  ${breakpoint('desktop')`
    display: block;
    margin-bottom: 60px;
  `};
`;

const Button = styled.button`
  border: none;
  outline: none;
  border-radius: 3px;
  font-size: 14px;
  line-height: 16px;
  padding: 11px 42px;
  cursor: pointer;
  border: 1px solid #0079ff;
  color: #0079ff;
  background-color: #fff;

  &.active {
    color: #fff;
    background-color: #0079ff;
  }
`;

const Table = styled.table`
  text-align: center;
  width: 1000px;
  max-width: 100%;

  & > thead > tr > td:last-of-type {
    border-top-color: #afd5ff;
    padding: 15px 0;
  }

  & > tfoot > tr > td:last-of-type {
    border-bottom-color: #afd5ff;
  }
`;

const Tr = styled.tr``;

const Td = styled.td`
  width: 300px;
  border: 1px solid #f1f1f1;
  padding: 13px 10px;
  color: #686868;
  font-size: 14px;
  line-height: 16px;
  border-right-color: #afd5ff;

  &:first-of-type {
    width: 400px;
    text-align: left;
    border-right-color: #f1f1f1;
  }
`;

const Th = styled.th`
  background-color: #f1f1f1;
  border: 1px solid #f1f1f1;
  padding: 6px 10px;
  color: #686868;
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  border-right-color: #afd5ff;

  &:first-of-type {
    text-align: left;
    border-right-color: #f1f1f1;
  }
`;

const TableBlock = () => {
  return (
    <React.Fragment>
      <Mobile>
        <TableMobile />
      </Mobile>
      <Desktop>
        <Table>
          <thead>
            <Tr>
              <Td style={{ borderTop: 'none', borderLeft: 'none' }}></Td>
              <Td>Lite</Td>
              <Td>Standart</Td>
            </Tr>
            <Tr>
              <Th>
                <FormattedMessage
                  id="shop.table.options"
                  defaultMessage="ОПЦИИ"
                />
              </Th>
              <Th>
                <FormattedMessage
                  id="shop.table.lite.price"
                  defaultMessage="от 999 лей/месяц"
                />
              </Th>
              <Th>
                <FormattedMessage
                  id="shop.table.standart.price"
                  defaultMessage="от 1599 лей/месяц"
                />
              </Th>
            </Tr>
          </thead>
          <tbody>
            <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.free"
                  defaultMessage="Бесплатный хостинг"
                />
                <FormattedMessage
                  id="shop.table.free.tooltip"
                  defaultMessage="Аренда дискового (серверного) пространства, где будут храниться все необходимые для правильного функционирования сайта файлы и данные."
                >
                  {message => <Tip message={message} />}
                </FormattedMessage>
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr>
            <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.mobile"
                  defaultMessage="Мобильная версия"
                />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr>
            <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.infinite"
                  defaultMessage="Неограниченное количество товаров"
                />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr>
            <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.languages"
                  defaultMessage="Многоязычность и многовалютность"
                />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr>
            <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.onec"
                  defaultMessage="1С синхронизация"
                />
                <FormattedMessage
                  id="shop.table.onec.tooltip"
                  defaultMessage="Выгрузка товаров из базы через XML файл по расписанию."
                >
                  {message => <Tip message={message} />}
                </FormattedMessage>
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr>
            <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.seo"
                  defaultMessage="SEO возможности"
                />
                <FormattedMessage
                  id="shop.table.seo.tooltip"
                  defaultMessage="Поля TITLE, KEYWORDS, DESCRIPTION в личном кабинете, которые помогут поднять разделы на первые позиции в результатах выдачи, с целью увеличения посещаемости."
                >
                  {message => <Tip message={message} />}
                </FormattedMessage>
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr>
            {/* <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.mail"
                  defaultMessage="Корпоративная почта"
                />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr> */}
            <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.paynet"
                  defaultMessage="Подключение PAYNET и PAYPAL"
                />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr>
            <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.integration"
                  defaultMessage="Интеграция с E-mail сервисом"
                />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr>
            <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.pays"
                  defaultMessage="Подключение оплат VISA/Mastercard"
                />
              </Td>
              <Td>
                <img src={Close} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr>
            <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.feed"
                  defaultMessage="Создание FEED XML Facebook и Google"
                />
              </Td>
              <Td>
                <img src={Close} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr>
            <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.module"
                  defaultMessage="Модуль: просмотренных товаров"
                />
              </Td>
              <Td>
                <img src={Close} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr>
            <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.cabinet"
                  defaultMessage="Модуль: Личный кабинет"
                />
              </Td>
              <Td>
                <img src={Close} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr>
            <Tr>
              <Td>
                <FormattedMessage
                  id="shop.table.ssl"
                  defaultMessage="Бесплатный SSL - Сертификат"
                />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
              <Td>
                <img src={Check} alt="" />
              </Td>
            </Tr>
          </tbody>
          <tfoot>
            <Tr>
              <Td style={{ borderBottom: 'none', borderLeft: 'none' }}></Td>
              <Td>
                <Button
                  onClick={() =>
                    window.clickButton('b24-web-form-popup-btn-16')
                  }
                >
                  <FormattedMessage
                    id="shop.table.tfoot.choose.lite"
                    defaultMessage="Выбрать Lite"
                  />
                </Button>
              </Td>
              <Td>
                <Button
                  className="active"
                  onClick={() =>
                    window.clickButton('b24-web-form-popup-btn-12')
                  }
                >
                  <FormattedMessage
                    id="shop.table.tfoot.choose.standart"
                    defaultMessage="Выбрать Standart"
                  />
                </Button>
              </Td>
            </Tr>
          </tfoot>
        </Table>
      </Desktop>
    </React.Fragment>
  );
};

export default TableBlock;



// WEBPACK FOOTER //
// ./src/routes/Shop/blocks/table.js